module.exports = __webpack_public_path__ + "img/complain.a4131190.png";